<template>
  <div class="main-container alarm-table-height">
    <div style="width: 100%">
      <!-- <div class="table-header-custom" style="margin-bottom: 12px">
        <el-input
          style="width: 100%"
          placeholder="Search here..."
          v-model="searchTerm"
          prefix-icon="el-icon-search"
        ></el-input>
      </div>-->
      <!-- <div class="search-div" style="width: 100% ; display: block">
        <el-input
          style="max-width: 200px; display: none"
          placeholder="Device ID"
          prefix-icon="el-icon-search"
          v-model="searchDeviceId"
        ></el-input>

        <el-date-picker
          v-model="filterDate"
          type="datetimerange"
          range-separator="-"
          start-placeholder="Start date"
          end-placeholder="End date"
          align="center"
          style="width: 75%"
        ></el-date-picker>

        <button
          class="btn btn-primary"
          style="width: 20%"
          @click="searchWarnings"
          :disabled="isLoading"
        >
          {{ isLoading ? "Loading..." : "Load alarms" }}
        </button>
      </div> -->

      <div v-if="isLoading" class="loading">loading, please wait...</div>

      <vue-good-table
        :columns="tableOptions"
        :search-options="{
          enabled: false,
          externalQuery: searchTerm
        }"
        :sort-options="{
          enabled: true,
          initialSortBy: { field: 'startTime', type: 'desc' }
        }"
        :rows="list"
        v-else
        :pagination-options="{ enabled: false }"
        :line-numbers="true"
      >
        <template slot="table-row" slot-scope="props">
          <div>
            <span v-if="props.column.field == 'name'">{{
              props.row["name"] ? props.row["name"] : "---"
            }}</span>
            <span v-if="props.column.field == 'deviceId'">{{
              props.row["deviceId"] ? props.row["deviceId"] : "---"
            }}</span>
            <span v-if="props.column.field == 'fault'">{{
              props.row["fault"] ? props.row["fault"] : "---"
            }}</span>
            <span
              v-if="props.column.field == 'severity'"
              :class="
                props.row['severity'] == 'Minor'
                  ? 'badge badge-dark'
                  : props.row['severity'] == 'Major'
                  ? 'badge badge-warning'
                  : 'badge badge-warning'
              "
              >{{ props.row["severity"] ? props.row["severity"] : "--" }}</span
            >
            <span
              v-if="props.column.field == 'status'"
              :class="
                props.row['status'] == 'RESOLVED'
                  ? 'statusLabel badge badge-success'
                  : 'statusLabel badge badge-danger'
              "
              >{{ props.row["status"] ? props.row["status"] : "--" }}</span
            >
            <span v-if="props.column.field == 'startTime'">{{
              props.row["startTime"] ? props.row["startTime"] : "--"
            }}</span>

            <span v-if="props.column.field == 'endTime'">{{
              props.row["endTime"] ? props.row["endTime"] : "--"
            }}</span>
          </div>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
            :perPage="100"
          ></grey-pagination>
        </template>
      </vue-good-table>

      <!-- <infinite-loading @infinite="infiniteHandler"></infinite-loading> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import format from "date-fns/format";
import { DatePicker } from "element-ui";
import moment from "moment";
import { Select, Button, Autocomplete, Form, FormItem } from "element-ui";
moment.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

const items = [];
export default {
  data() {
    return {
      searchDeviceId: null,
      searchTerm: "",
      items: items,
      warningTimerId: null,
      tableOptions: [
        {
          field: "name",
          label: "Name",
          sortable: true,
          type: "text",
          filterable: true,
          width: "17%",
          filterOptions: {
            styleClass: "", // class to be added to the parent th element
            enabled: true, // enable filter for this column
            placeholder: "Filter by Name", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [],
            filterFn: function(data, filterString) {
              if (data.toLowerCase().includes(filterString.toLowerCase())) {
                return data;
              }
            },
            trigger: "enter"
          }
          // sortFn: function(x, y, col, rowX, rowY) {
          // console.log({ x, y, dir: x < y ? "up" : x > y ? "down" : "stay" });
          // x = Number(x);
          // y = Number(y);
          // console.log({ x, y, dir: x < y ? "up" : x > y ? "down" : "stay" });
          // return x < y ? -1 : x > y ? 1 : 0;
          // }
        },
        {
          field: "deviceId",
          label: "DeviceID",
          sortable: true,
          type: "number",
          filterable: true,
          width: "17%",
          filterOptions: {
            styleClass: "", // class to be added to the parent th element
            enabled: true, // enable filter for this column
            placeholder: "Filter by Device Id", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: function(data, filterString) {
              // console.log({ data, filterString });

              if (data.toLowerCase().includes(filterString.toLowerCase())) {
                return data;
              }
            },
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          field: "fault",
          label: "Fault",
          sortable: true,
          type: "text",
          filterable: true,
          width: "17%",
          filterOptions: {
            styleClass: "", // class to be added to the parent th element
            enabled: true, // enable filter for this column
            placeholder: "Filter by Fault", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: function(data, filterString) {
              // console.log({ data, filterString });

              if (data.toLowerCase().includes(filterString.toLowerCase())) {
                return data;
              }
            },
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          field: "startTime",
          label: "Start Time",
          sortable: true,
          type: "date",
          dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSxxx", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy", // outputs Mar 16th 2018
          filterable: true,
          width: "17%"
        },

        {
          field: "severity",
          label: "Severity",
          sortable: true,
          type: "text",
          filterable: true,
          width: "17%",
          filterOptions: {
            styleClass: "", // class to be added to the parent th element
            enabled: true, // enable filter for this column
            placeholder: "Filter by Severity", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [
              "Major",
              "Minor",
              "Critical",
              "Major & Critical"
            ], // dropdown (with selected values) instead of text input
            filterFn: function(data, filterString) {
              if (filterString == `Major & Critical`) {
                if (
                  data.toLowerCase().includes(`Major`.toLowerCase()) ||
                  data.toLowerCase().includes(`Critical`.toLowerCase())
                ) {
                  return data;
                }
              } else if (
                data.toLowerCase().includes(filterString.toLowerCase())
              ) {
                return data;
              }
            },
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          field: "status",
          label: "Status",
          sortable: true,
          type: "text",
          filterable: true,
          width: "17%",
          filterOptions: {
            styleClass: "", // class to be added to the parent th element
            enabled: true, // enable filter for this column
            placeholder: "Filter by Status", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ["Open", "Resolved"], // dropdown (with selected values) instead of text input
            filterFn: function(data, filterString) {
              if (data.toLowerCase().includes(filterString.toLowerCase())) {
                return data;
              }
            },
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
        {
          field: "endTime",
          label: "End Time",
          sortable: true,
          type: "text",
          filterable: true,
          width: "17%"
        },

        {
          field: "action",
          label: "",
          hidden: true
        }
      ],
      list: "",
      currentPage: 1,
      perPage: 10,
      isLoading: false,
      filterDate: null
    };
  },
  components: {
    "el-date-picker": DatePicker
  },
  computed: {
    ...mapGetters(["getUserById", "getDummy", "getUserSession"])
  },
  methods: {
    infiniteHandler($state) {
      // axios
      //   .get(api, {
      //     params: {
      //       page: this.page,
      //     },
      //   })
      //   .then(({ data }) => {
      //     if (data.hits.length) {
      //       this.page += 1;
      //       this.list.push(...data.hits);
      //       $state.loaded();
      //     } else {
      //       $state.complete();
      //     }
      //   });
    },
    numSort(x, y, col, rowX, rowY) {
      console.log({ x, y, dir: x < y ? "up" : x > y ? "down" : "stay" });
      x = Number(x);
      y = Number(y);
      //  console.log({ x, y,dir: x < y ? "up" : x > y ? "down" : "stay" });
      return x < y ? -1 : x > y ? 1 : 0;
    },
    viewStatus(row) {
      this.$emit("onRowClick", row);
      this.$emit("showOffCanvas");
    },
    async searchWarnings() {
      const lowerLimit =
        this.filterDate == null
          ? moment()
              .subtract(3, "days")
              .toISOString()
          : this.filterDate[0].toISOString();

      const upperLimit =
        this.filterDate != null
          ? this.filterDate[1].toISOString()
          : moment().toISOString();
      // const inverterId = this.searchDeviceId;

      this.list = await this.init(lowerLimit, upperLimit, null); //lowerLimit, upperLimit, inverterId
    },
    searchTable(list, tableOptions, cellValue, searchTerm) {
      return (
        Object.values(list)
          .join("<%>")
          .toLowerCase()
          .indexOf(searchTerm.toLowerCase()) > -1
      );
    },
    sleep(ms) {
      return new Promise(resolve => {
        this.warningTimerId = setTimeout(resolve, ms);
        return this.warningTimerId;
      });
    },
    formatDate(date) {
      return moment(date).format("Do MMM YYYY");
    },
    async init(lowerLimit = null, upperLimit = null, inverterId = null) {
      const defaultDiff = 3;
      try {
        const httpUtils = this.$httpUtils;
        let smQuery = ``;
        if (this.$can("am", "sm")) {
          let assignedDevices = this.getUserSession.assignedDevices;
          smQuery = `
            {
              surveillanceByDateAndIDs(DateRange:["${lowerLimit ||
                moment()
                  .subtract(defaultDiff, "days")
                  .toISOString()}","${upperLimit ||
            moment().toISOString()}"],IDs:${assignedDevices || []}){
                deviceId
                fault
                severity
                status
                id
                startTime
                endTime
              }
            }
          `;
        }

        let query = `
          {
            surveillance{
              deviceId
              fault
              startTime
              endTime
              id
              name
              severity
              status
            }
          }
        `;

        let filterQuery = `{
          surveillanceByDate(DateRange:["${lowerLimit ||
            moment()
              .subtract(defaultDiff, "days")
              .toISOString()}","${upperLimit || moment().toISOString()}"]){
            deviceId
            fault
            name
            startTime
            status
            id
            severity
            endTime
          }
        }`;

        const GraphHTTP = this.$httpUtils.GraphHTTP;
        // console.log({rrr:this.$can("am", "sm")==true?smQuery: filterQuery});
        // console.log({rrr:null == lowerLimit || null == upperLimit ? this.$can("am", "sm")?smQuery:query: filterQuery});
        // let url = `/warning_reports?filter=${JSON.stringify(filter)}`;
        const res = await GraphHTTP.post("/graphql", {
          query: this.$can("am", "sm") == true ? smQuery : filterQuery
        });
        // const res = await GraphHTTP.post("/graphql", {
        //   query: this.$can("am", "sm") == true ? smQuery : filterQuery
        // });
        // var format = require("date-fns/format");
        // console.log({ warning: res.data });
        let {
          surveillance,
          surveillanceByDate,
          surveillanceByDateAndIDs
        } = res.data.data;

        // console.log({surveillance,surveillanceByDate, surveillanceByDateAndIDs});
        let yo =
          surveillance || surveillanceByDate || surveillanceByDateAndIDs || [];
        let goodWarning = yo.map(v => ({
          deviceId: v.deviceId,
          fault: v.fault,
          severity: v.severity,
          status: v.status,
          startTime: format(
            new Date(v.startTime),
            "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"
          ), //`${moment(v.startTime).format("YYYY-MM-DD HH:mm:ss")}`,
          endTime: v.endTime
            ? `${format(new Date(v.endTime), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")}`
            : v.endTime,
          name: v.name
        }));

        this.list = goodWarning;
      } catch (error) {
        console.log("init ==>", error);
      } finally {
        this.isLoading = false;
        //This bit reruns the function so as to update the data at intervals. Helps to achieve realtime reporting
        // setTimeout(this.init(), 300000)
        this.sleep(300000).then(() => {
          // console.log("running cron!!!", new Date());
          this.init();
        });
      }
    }
  },
  beforeDestroy() {
    if (!this.warningTimerId) return;
    clearTimeout(this.warningTimerId);
  },
  async mounted() {
    this.isLoading = true;
    await this.init();
  }
};
</script>

<style scoped>
.loading {
  width: 100%;
  padding: 100px 0;
  text-align: center;
}

.badge-success {
  background: #35ae47 !important;
}

.badge-danger {
  background-color: #eb3b48 !important;
}
.badge-warning {
  background-color: #f48221 !important;
}
.badge-info {
  background-color: #6c757d !important;
}
.badge-dark {
  background-color: #007bff !important;
}

.badge {
  min-width: 123px;
  display: inline-block;
  font-weight: normal;
  text-transform: capitalize;
  font-size: 8pt;
  letter-spacing: 0.0625rem;
  color: #fff;
  border-radius: 10pt;
}
.alarm-table-height {
  height: calc(100vh - 225px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/warnings/warnings.vue